import * as React from 'react';
import SupportedBrowserAlert from './SupportedBrowserAlert';
import { useLocation } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  showBrowserAlert?: boolean;
};

const Viewport: React.FunctionComponent<Props> = (props) => {
  const { children, showBrowserAlert = true, ...rest } = props;
  const location = useLocation();
  return (
    <div
      role="main"
      className="viewport"
      data-location-path={location.pathname}
      {...rest}
    >
      <div className="prs-container">
        {showBrowserAlert && (
          <SupportedBrowserAlert iconSize={25} isClosable={true} />
        )}
        {children}
      </div>
    </div>
  );
};

export default Viewport;
